export const SORT_KEYS = {
  NAME: 'name',
} as const;

export const SORT_DIRECTIONS = {
  ASC: 'asc',
  DESC: 'desc',
  NONE: '',
} as const;

export const MESSAGES = {
  SUCCESS: {
    CREATED: 'Device type created successfully.',
    UPDATED: 'Device type updated successfully.',
    DELETED: 'Device type deleted successfully.',
  },
  ERROR: {
    FETCH: 'Error fetching device types.',
    CREATE: 'Error creating device type.',
    UPDATE: 'Error updating device type.',
    DELETE: 'Error deleting device type.',
    VALIDATION: {
      NAME_REQUIRED: 'Name is required',
    },
  },
  CONFIRM: {
    DELETE_TITLE: 'Confirm Deletion',
    DELETE_MESSAGE: 'Are you sure you want to delete',
    UNSAVED_TITLE: 'Unsaved Changes',
    UNSAVED_MESSAGE: 'You have unsaved changes. Are you sure you want to cancel?',
    DELETE_NOTE: 'You cannot delete this device type if there are devices associated with it. Please remove any associated devices first.',
  },
} as const;

export const PLACEHOLDERS = {
  SEARCH: 'Search device types...',
  NAME: 'Enter device type name',
} as const;

export const LABELS = {
  NAME: 'Name',
  ACTIONS: 'Actions',
  ADD_DEVICE_TYPE: 'Add Device Type',
  BACK: 'Back',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  DELETE: 'Delete',
  EDIT: 'Edit',
  TOTAL_DEVICE_TYPES: 'Total Device Types',
  ACTIVE_TYPES: 'Active Types',
  ADD_NEW_TYPE: 'Add New Type',
  DEVICE_TYPE_LIST: 'Device Type List',
  NO_DEVICE_TYPES: 'No device types found',
  START_ADDING: 'Start by adding your first device type',
  ADJUST_SEARCH: 'Try adjusting your search criteria',
  LOADING: 'Loading device types...',
} as const;

export const STATS = {
  AVAILABLE_CONFIGURATIONS: 'Available configurations',
  CURRENTLY_AVAILABLE: 'Currently available',
  CREATE_CONFIGURATION: 'Create configuration',
} as const;

export const VALIDATION_RULES = {
  NAME: [
    {
      required: true,
      message: MESSAGES.ERROR.VALIDATION.NAME_REQUIRED,
    },
  ],
};
